#import "@/apollo/fragments/Client.gql"

mutation UpdateClient(
    $clientId: ID!
    $content: String!
    $name: String
    $imageProcessingEnabled: Boolean
    $fbAdsManagerConfig: InputFacebookAdsManagerConfig
    $distributionChannel: DistributionChannel
    $creativeXPlatformSettings: InputCreativeXPlatformSettings
) {
    updateClient(
        clientId: $clientId
        content: $content
        name: $name
        imageProcessingEnabled: $imageProcessingEnabled
        fbAdsManagerConfig: $fbAdsManagerConfig
        distributionChannel: $distributionChannel
        creativeXPlatformSettings: $creativeXPlatformSettings
    ) {
        ...Client
        fbAdsManagerConfig {
            businessId
            adAccountId
        }
        creativeXPlatformSettings {
            enabled
            brandId
            threshold
        }
    }
}
